import React from "react";
import LoginPageComponent from "../components/loginPageComponent/loginPageComponent";


export default function Login() {
    return <LoginPageComponent />

}